export default "__VITE_ASSET__DxiPqLrb__"